import { AUTO } from "./processCarrierWorkbook";
import { CARRIERS, findCarrier } from "./carriers";

const NEUTRAL_BADGE = "bg-gray-100 text-gray-700 ring-gray-200";

export function carrierBadgeClass(carrier) {
  return findCarrier(carrier)?.badgeClass || NEUTRAL_BADGE;
}

export function kpiBadgeClass(value) {
  if (value === true) return "bg-emerald-100 text-emerald-700 ring-emerald-200";
  if (value === false) return "bg-red-100 text-red-700 ring-red-200";
  return "bg-slate-100 text-slate-600 ring-slate-200";
}

export function kpiLabel(value) {
  if (value === true) return "YES";
  if (value === false) return "NO";
  return "EXCLUDED";
}

export function formatCarrierLabel(value) {
  const match = CARRIERS.find(
    (carrier) => carrier.id.toUpperCase() === String(value ?? "").toUpperCase()
  );
  return match?.label || value || "Unknown";
}

export const carrierOptions = [
  { label: "Auto Detect", value: AUTO },
  ...CARRIERS.map((carrier) => ({ label: carrier.label, value: carrier.id })),
];
